import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { browserHistory } from 'react-router'
import Spinner from '../Spinner'
import { Modal, Button } from 'react-bootstrap'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as actions from '../../../state/actions'
import isEqual from 'lodash/isEqual'

class List extends Component {
    constructor(props) {
        super(props)
        const location = props.routing && (props.routing.location || props.routing.locationBeforeTransitions)

        this.state = {
            loading: false,
            skip: (location && location.query && location.query.skip) ? parseInt(location.query.skip) : 0,
            limit: (location && location.query && location.query.limit) ? parseInt(location.query.limit) : (props.limit || 10),
            modal: {
                data: {
                    title: null,
                    description: null,
                    button: {
                        cancel: {
                            title: null,
                            className: null
                        },
                        success: {
                            title: null,
                            className: null,
                            onClick: null,
                            onClickBind: null
                        },
                        moreButtons: []
                    }
                },
                metadata: {},
                show: false
            }
        }

        this.openModal = this.openModal.bind(this)
        this.closeModal = this.closeModal.bind(this)
        this.goPrevPage = this.goPrevPage.bind(this)
        this.goNextPage = this.goNextPage.bind(this)
        this.limitChanged = this.limitChanged.bind(this)
        this.refreshData = this.refreshData.bind(this)
    }

    componentDidMount() {
        var self = this
        var params = Object.assign({}, self.props.params)
        params.skip = self.state.skip * self.state.limit
        params.limit = self.state.limit
        self.setState({ loading: true })
        return Promise.resolve().then(() => {
            return self.props.getObjects(params)
        }).then(() => {
            self.setState({ loading: false })
        })
    }

    componentDidUpdate() {
        var self = this
        var location = this.props.routing && (this.props.routing.location || this.props.routing.locationBeforeTransitions)
        if (location) {
            var params = Object.assign({}, location.query)
            params['limit'] = self.state.limit.toString()
            params['skip'] = self.state.skip.toString()
            if (self.props.params && self.props.params.query) {
                var mapQueryParams = Object.keys(self.props.params.query)
                mapQueryParams.forEach(param => {
                    if (typeof self.props.params.query[param] !== 'object') {
                        params[param] = self.props.params.query[param]
                    }
                })
            }

            if (!isEqual(location.query, params)) {
                location.query = params
                browserHistory.replace(location)
            }
        }
    }

    openModal(data, metadata) {
        var self = this
        var currentState = self.state
        currentState.modal.data = data
        currentState.modal.metadata = metadata
        currentState.modal.show = true
        return new Promise(function(resolve, reject) {
            self.setState(currentState, resolve)
        })
    }

    closeModal() {
        var self = this
        var currentState = self.state
        currentState.modal.show = false
        return new Promise(function(resolve, reject) {
            self.setState(currentState, resolve)
        })
    }

    goPrevPage() {
        var self = this
        var newSkip = self.state.skip - 1
        if (newSkip < 0) {
            newSkip = 0
        }
        self.setState({ skip: newSkip })
        return Promise.resolve().then(() => {
            var params = Object.assign({}, self.props.params)
            params.skip = self.state.skip * self.state.limit
            params.limit = self.state.limit
            self.setState({ loading: true })
            return Promise.resolve().then(() => {
                return self.props.getObjects(params)
            }).then(() => {
                self.setState({ loading: false })
            })
        })
    }

    goNextPage() {
        var self = this
        var newSkip = self.state.skip + 1
        self.setState({ skip: newSkip })
        return Promise.resolve().then(() => {
            var params = Object.assign({}, self.props.params)
            params.skip = self.state.skip * self.state.limit
            params.limit = self.state.limit
            self.setState({ loading: true })
            return Promise.resolve().then(() => {
                return self.props.getObjects(params)
            }).then(() => {
                self.setState({ loading: false })
            })
        })
    }

    limitChanged(e) {
        var self = this
        var newLimit = parseInt(e.target.value)
        self.setState({ limit: newLimit, skip: 0 })
        return Promise.resolve().then(() => {
            var params = Object.assign({}, self.props.params)
            params.skip = self.state.skip * self.state.limit
            params.limit = self.state.limit
            self.setState({ loading: true })
            return Promise.resolve().then(() => {
                return self.props.getObjects(params)
            }).then(() => {
                self.setState({ loading: false })
            })
        })
    }

    refreshData(useSkip) {
        var self = this
        var newSkip = 0
        if (useSkip) {
            newSkip = self.state.skip
        } else {
            self.setState({ skip: newSkip })
        }
        return Promise.resolve().then(() => {
            var params = Object.assign({}, self.props.params)
            params.skip = self.state.skip * self.state.limit
            params.limit = self.state.limit
            self.setState({ loading: true })
            return Promise.resolve().then(() => {
                return self.props.clearObjects()
            }).then(() => {
                return self.props.getObjects(params)
            }).then(() => {
                self.setState({ loading: false })
            })
        })
    }

    render() {
        var self = this
        var listTable = null
        var pageSizes = [10, 25, 50, 100]
        if (process.env.MT_ENV === 'development') {
            pageSizes.unshift(1)
        }

        if (self.props.items) {
            var listTableBody = null
            if (self.state.loading) {
                listTableBody = (
                    <tbody>
                        <tr>
                            <td colSpan={ self.props.dataColumnsNames.length }>
                                <Spinner />
                            </td>
                        </tr>
                    </tbody>
                )
            } else if (self.props.items.length) {
                listTableBody = (
                    <tbody>
                        {
                            self.props.items.map(function (object, objectIndex) {
                                return (
                                    <tr key={'row_' + objectIndex} ref={'row_' + objectIndex}>
                                        {
                                            object.map(function(columnValue, columnIndex) {
                                                return (
                                                    <td key={'column_' + columnIndex} ref={'column_' + columnIndex}>
                                                        { columnValue }
                                                    </td>
                                                )
                                            })
                                        }
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                )
            } else {
                listTableBody = (
                    <tbody>
                        <tr>
                            <td colSpan={ self.props.dataColumnsNames.length }>
                                No hay más objetos para mostrar
                            </td>
                        </tr>
                    </tbody>
                )
            }

            var listTableHeader = (
                <thead>
                    <tr>
                        {
                            self.props.dataColumnsNames.map(function(columnName, columnIndex) {
                                return (
                                    <th key={'header_' + columnIndex}>{ columnName }</th>
                                )
                            })
                        }
                    </tr>
                </thead>
            )

            var listTableFooterPrevButton = null
            var listTableFooterNextButton = null

            if (self.props.allowPagination) {
                if (self.state.skip > 0) {
                    listTableFooterPrevButton = <button onClick={ self.goPrevPage } className="btn btn-default"><i className="fa fa-angle-left"></i> Previos { self.state.limit }</button>
                }
                if (self.state.limit === self.props.items.length) {
                    listTableFooterNextButton = <button onClick={ self.goNextPage } className="btn btn-default">Siguientes { self.state.limit} <i className="fa fa-angle-right"></i></button>
                }
            }

            var listTableFooter = (
                <tfoot>
                    <tr>
                        <td colSpan={ self.props.dataColumnsNames.length }>
                            <div className="pull-left">
                                { listTableFooterPrevButton }
                                &nbsp;&nbsp;
                                { listTableFooterNextButton }
                            </div>
                            <div className="pull-right">
                                {self.props.displayLimit && <label>
                                    Mostrar
                                    &nbsp;
                                    <select className="form-control input-sm" defaultValue={ self.state.limit } onChange={ self.limitChanged }>
                                        {
                                            pageSizes.map(function(value) {
                                                return (
                                                    <option value={ value } key={ value }>{ value }</option>
                                                )
                                            })
                                        }
                                    </select>
                                </label>}
                                &nbsp;
                                <button onClick={ self.refreshData.bind(self, false) } className="btn btn-default"><i className="fa fa-refresh fa-fw"></i></button>
                            </div>
                        </td>
                    </tr>
                </tfoot>
            )
            listTable = (
                <table className="table table-striped table-bordered table-hover table-responsive">
                    { listTableHeader }
                    { listTableBody }
                    { listTableFooter }
                </table>
            )
        } else {
            listTable = (
                <Spinner />
            )
        }

        var modalFooterCancelButton
        var modalFooterSuccessButton
        var modalFooterMoreButtons = false

        if (self.state.modal.data && self.state.modal.data.button && self.state.modal.data.button.cancel && self.state.modal.data.button.cancel.title) {
            modalFooterCancelButton = <Button className={ self.state.modal.data.button.cancel.className } onClick={ self.closeModal.bind(self) }>{ self.state.modal.data.button.cancel.title }</Button>
        }
        if (self.state.modal.data && self.state.modal.data.button && self.state.modal.data.button.success && self.state.modal.data.button.success.title) {
            var onClickCall
            if (self.state.modal.data.button.success && self.state.modal.data.button.success.onClick && self.state.modal.data.button.success.onClickBind) {
                onClickCall = self.state.modal.data.button.success.onClick.bind(self.state.modal.data.button.success.onClickBind, self.state.modal.metadata)
            }
            modalFooterSuccessButton = <Button className={ self.state.modal.data.button.success.className } onClick={ onClickCall }>{ self.state.modal.data.button.success.title }</Button>
        }

        if (self.state.modal.data && self.state.modal.data.button && self.state.modal.data.button.moreButtons && self.state.modal.data.button.moreButtons.length) {
            modalFooterMoreButtons = true
        }

        var modal = <div className="static-modal">
            <Modal show={self.state.modal.show} onHide={ self.closeModal.bind(self) }>
                <Modal.Header closeButton>
                    <Modal.Title>{ self.state.modal.data && self.state.modal.data.title }</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h5>{ self.state.modal.data && self.state.modal.data.description }</h5>
                </Modal.Body>
                <Modal.Footer>
                    { modalFooterCancelButton }
                    { modalFooterSuccessButton }
                    { modalFooterMoreButtons && self.state.modal.data.button.moreButtons.map(function(button, index) {
                        if (button.title && button.className) {
                            var onClickCall
                            if (button.onClick && button.onClickBind) {
                                onClickCall = button.onClick.bind(button.onClickBind, self.state.modal.metadata)
                            }
                            return <Button key={'moreButtons-' + index} className={button.className} onClick={ onClickCall }>{button.title}</Button>
                        }
                    }) }
                </Modal.Footer>
            </Modal>
        </div>

        return (
            <div>
                <div className="row">
                    <div className="col-lg-12">
                        <h1 className="page-header">{ self.props.name }</h1>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="row">
                            <div className="col-sm-12">
                                { self.props.listHeader }
                            </div>
                        </div>
                        {(self.props.description || self.props.listHeader) &&
                            <div className="panel panel-default">
                                <div className="panel-heading">
                                    { self.props.description }
                                </div>
                                <div className="panel-body">
                                    <div className="dataTable_wrapper">
                                        <div className="dataTables_wrapper form-inline dt-bootstrap no-footer">
                                            <div className="row">
                                                <div className="col-sm-12" style={{ overflowY: 'auto' }}>
                                                    { listTable }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> ||
                            <div className="dataTable_wrapper">
                                <div className="dataTables_wrapper form-inline dt-bootstrap no-footer">
                                    <div className="row">
                                        <div className="col-sm-12" style={{ overflowY: 'auto' }}>
                                            { listTable }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                { modal }
            </div>
        )
    }
}

List.propTypes = {
    items: PropTypes.array,
    name: PropTypes.string.isRequired,
    description: PropTypes.element,
    dataColumnsNames: PropTypes.array.isRequired,
    lastColumnWidth: PropTypes.string,
    listHeader: PropTypes.element,
    getObjects: PropTypes.func.isRequired,
    clearObjects: PropTypes.func.isRequired,
    allowPagination: PropTypes.bool,
    params: PropTypes.object,
    limit: PropTypes.number.isRequired,
    displayLimit: PropTypes.bool
}

List.defaultProps = {
    lastColumnWidth: 'col-sm-1',
    allowPagination: true,
    displayLimit: true
}

function mapStateToProps(state) {
    return {
        routing: state.routing
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(List)



// WEBPACK FOOTER //
// ./components/common/List/index.js